import { LicenseValue } from './license.value';

export class LicenseValueDto {
    endAt: string;

    constructor(data: LicenseValue) {
        this.endAt = data.endAt;
    }
}
